import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { PWAInstallPrompt, PushNotificationPrompt } from "./components/PWAComponents";

// Pages
import LandingPage from "./pages/LandingPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import AuthCallback from "./pages/AuthCallback";
import SubscriptionPage from "./pages/SubscriptionPage";
import SubscriptionSuccess from "./pages/SubscriptionSuccess";
import LetterReader from "./pages/LetterReader";
import ArchivePage from "./pages/ArchivePage";
import AccountPage from "./pages/AccountPage";
import LibraryPage from "./pages/LibraryPage";
import SeriesArchive from "./pages/SeriesArchive";
import SeriesLetterReader from "./pages/SeriesLetterReader";
import AdminDashboard from "./pages/AdminDashboard";
import ProtectedRoute from "./components/ProtectedRoute";

import "./App.css";

function PWAPrompts() {
  const { token, isAuthenticated } = useAuth();
  
  return (
    <>
      <PWAInstallPrompt />
      {isAuthenticated && <PushNotificationPrompt token={token} />}
    </>
  );
}

function AppRouter() {
  const location = useLocation();
  
  // CRITICAL: Check for session_id in hash BEFORE rendering routes
  // This prevents race conditions with auth checks
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/admin" element={<AdminDashboard />} />
      <Route path="/subscription" element={
        <ProtectedRoute>
          <SubscriptionPage />
        </ProtectedRoute>
      } />
      <Route path="/subscription/success" element={
        <ProtectedRoute>
          <SubscriptionSuccess />
        </ProtectedRoute>
      } />
      <Route path="/letter/:weekNumber" element={<LetterReader />} />
      <Route path="/archive" element={
        <ProtectedRoute>
          <ArchivePage />
        </ProtectedRoute>
      } />
      <Route path="/library" element={
        <ProtectedRoute>
          <LibraryPage />
        </ProtectedRoute>
      } />
      <Route path="/series/:seriesId" element={
        <ProtectedRoute>
          <SeriesArchive />
        </ProtectedRoute>
      } />
      <Route path="/series/:seriesId/letter/:weekNumber" element={<SeriesLetterReader />} />
      <Route path="/account" element={
        <ProtectedRoute>
          <AccountPage />
        </ProtectedRoute>
      } />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <PWAPrompts />
        <Toaster position="bottom-right" />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
